import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { home } from "@paths";
import { db, persistUserData } from "@client";
import { exchangeImpersonationCode } from "@query";
import { saveImpersonationSession, takeHandoffFromLocation } from "@utils";
import { useStores } from "@hooks";
import { Button } from "@components";
import { CircularProgress, Paper } from "@material-ui/core";

const enabled = ["1", "true", "yes"].includes(
  String(import.meta.env.APP_ROOT_IMPERSONATION_ENABLED).toLowerCase(),
);

export const Handoff = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userStore } = useStores();
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;

    (async () => {
      const handoff = takeHandoffFromLocation();
      if (!enabled || !handoff) {
        if (mounted) setError(true);
        return;
      }

      try {
        const response = await exchangeImpersonationCode(handoff.code);
        const token = response.headers?.token;
        if (!token || !response.data?.user || !response.data?.impersonation)
          throw new Error("Invalid impersonation response");

        saveImpersonationSession(token, response.data.impersonation);
        await db.user.clear();
        await persistUserData(response.data.user.id, token, false);
        userStore.saveUserData(response.data.user);
        userStore.setImpersonation(response.data.impersonation);
        userStore.setLoginProcessStatus(true);
        navigate(handoff.returnPath || home, { replace: true });
      } catch (exchangeError) {
        console.log(exchangeError);
        if (mounted) setError(true);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Paper
      elevation={0}
      className="h-full flex flex-col items-center justify-center gap-4"
    >
      {error ? (
        <>
          <p>{t("impersonation.handoff.invalid")}</p>
          <Button onClick={() => location.replace(location.href)}>
            {t("impersonation.handoff.return_to_login")}
          </Button>
        </>
      ) : (
        <CircularProgress />
      )}
    </Paper>
  );
};
